import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "input", "toggle" ]

  toggle() {
    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text"
      this.toggleTarget.classList.remove("fa-eye")
      this.toggleTarget.classList.add("fa-eye-slash")
    } else {
      this.inputTarget.type = "password"
      this.toggleTarget.classList.remove("fa-eye-slash")
      this.toggleTarget.classList.add("fa-eye")
    }
  }
}
